import ValueHelper from "base/ValueHelper";
window.$ = window.jQuery;
import TouchGallery, {SWIPE_CHECK_DISTANCE} from "webPage/TouchGallery";
import EventEmitter from "base/EventEmitter";

export default class Track extends EventEmitter {
    constructor($element, options = {}) {
        super();

        this.options = $.extend(true, {}, Track.DEFAULT_OPTIONS, options);

        this.$element = $element;
        this.$wrap = $element.find(this.options.selectors.track);

        this.enabled = true;

        this.touching = false;
        this.swiping = false;
        this.touchStartX = null;
        this.touchStartY = null;

        this.transform = 0;
        this.touchStartTransform = 0;

        this.lastDragTime = null;
        this.lastDragX = 0;

        this.velocityInterval = null;
        this.velocityX = 0;
        this.velocityY = 0;

        this.clickTarget = null;

        this.maxTransform = 0;

        this.classes = {
            block: {
                base: this.options.classes.block,
            },
            track: {
                base: (this.options.classes.track ? this.options.classes.track : (this.options.classes.block + "__track")),
                dragging: (this.options.classes.track ? this.options.classes.track : (this.options.classes.block + "__track")) + "--dragging",
            },
        };

        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.handleMouseClick = this.handleMouseClick.bind(this);

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.bindEvents();

        TouchGallery.scroll_stoppers.push(this);

        this.updateMaxTransform();
        this.updateButtons();
    }

    _handleEnd() {
        if (Math.abs(this.getEffectiveVelocity()) > 0.01 && this.getTransform() === this.getEffectiveTransform()) {
            let time = (new Date).getTime();
            this.velocityInterval = setInterval(() => {
                let now = (new Date).getTime();
                let delta = now - time;
                time = now;

                this.offset(-this.getEffectiveVelocity() * delta, true);
                this.velocityX *= 0.95;
                this.velocityY *= 0.95;

                let effectiveVelocity = this.getEffectiveVelocity();

                if (Math.abs(effectiveVelocity) <= 0.1 || (Math.abs(effectiveVelocity) < 0.5 && this.getTransform() !== this.getEffectiveTransform())) {
                    this.stopVelocity();
                }
            });
        } else {
            this.stopVelocity();
        }

        this.touching = false;

        this.lastDragTime = null;
        this.lastDragX = 0;
        this.lastDragY = 0;
    }

    _handleMove(x, y) {
        let dragXOffset = x - this.touchStartX;
        let dragYOffset = y - this.touchStartY;

        let now = (new Date).getTime();
        if (this.lastDragTime !== null) {
            let dt = now - this.lastDragTime;

            this.velocityX = (dragXOffset - this.lastDragX) / dt;
            this.velocityY = (dragYOffset - this.lastDragY) / dt;
        }

        this.lastDragX = dragXOffset;
        this.lastDragY = dragYOffset;

        this.lastDragTime = now;

        // We haven't decided if we're swiping yet
        if (!this.swiping) {
            let totalDistance = Math.sqrt(Math.pow(dragXOffset, 2) + Math.pow(dragYOffset, 2));

            if (totalDistance > SWIPE_CHECK_DISTANCE) {
                // We want to scroll, not swipe
                if (this.getDirection() === HORIZONTAL && Math.abs(dragXOffset) < Math.abs(dragYOffset) / 1.5) {
                    return false;
                }

                this.swiping = true;
            }
        }

        this.setTransform(this.touchStartTransform - (this.getDirection() === HORIZONTAL ? dragXOffset : dragYOffset), true);
        return true;
    }

    _handleStart(x, y) {
        this.touching = true;
        this.swiping = false;
        this.touchStartTransform = this.transform;

        this.touchStartX = x;
        this.touchStartY = y;

        this.lastDragTime = null;
        this.lastDragX = 0;
        this.lastDragY = 0;

        this.velocityX = 0;
        this.velocityY = 0;

        if (this.velocityInterval) {
            clearInterval(this.velocityInterval);
        }

        this.$wrap.addClass(this.classes.track.dragging);
    }

    bindEvents() {
        TouchGallery.attach_listener(this.$wrap, "touchstart", this.onTouchStart);
        TouchGallery.attach_listener(this.$wrap, "mousedown", this.onMouseDown);

        const me = this;
        this.$element.on("click", this.options.selectors.button, function () {
            me.offset(($(this).attr("data-direction") === "forwards" ? 1 : -1) * me.getNavigateDistance());
            return false;
        });

        this.$element.find('img').on('load', () => {
            this.updateMaxTransform();
        });

        $(window).on("resize", () => {
            // Reclamp the transform
            this.updateMaxTransform();
            this.setTransform(this.getTransform());
        });
    }

    disable() {
        if (!this.enabled) {
            return;
        }
        this.enabled = false;
        this.updateMaxTransform();
        this.updateButtons();
        this.setTransform(0);
    }

    enable() {
        if (this.enabled) {
            return;
        }
        this.enabled = true;
        this.updateMaxTransform();
        this.updateButtons();
        this.setTransform(0);
    }

    getDirection() {
        return this.options.direction;
    }

    getEffectiveTransform() {
        // Get the normal transform, e.g. clamp it between 0 and the max transfer
        let normalised = ValueHelper.clamp(0, this.transform, this.getMaxTransform());

        // Get any extra transform to be applied over the ends
        let diff = Math.abs(this.transform) - Math.abs(normalised);

        // There is no extra transform to be applied, skip the maths
        if (diff === 0) {
            return this.transform;
        }

        return normalised + (diff * Math.pow(diff, -0.15) * (this.transform < 0 ? -1 : 1));
    }

    getEffectiveVelocity() {
        return this.getDirection() === HORIZONTAL ? this.velocityX : this.velocityY;
    }

    getItemSize() {
        let $watch = this.getItems().first();
        let margin = 0;
        let size = 0;

        if (this.getDirection() === HORIZONTAL) {
            margin += parseInt(this.$wrap.css('column-gap'));

            size = $watch.outerWidth();
        } else {
            margin += parseInt(this.$wrap.css('row-gap'));

            size = $watch.outerHeight();
        }

        return size + margin;
    }

    getItems() {
        return this.$wrap.find(this.options.selectors.item);
    }

    getMaxTransform() {
        return this.maxTransform;
    }

    getNavigateDistance() {
        if (this.options.getNavigateDistance instanceof Function) {
            return this.options.getNavigateDistance.call(this);
        }

        let count = this.options.navigateItemCount;
        if (count instanceof Function) {
            count = count.apply(this);
        }

        return this.getItemSize() * count;
    }

    getTransform() {
        return this.transform;
    }

    /**
     * Cancels the click event if we have been dragging
     *
     * @returns {boolean}
     */
    handleMouseClick() {
        return !this.swiping;
    }

    offset(distance, overDrag = false) {
        this.setTransform(this.getTransform() + distance, overDrag);
    }

    onMouseDown(e) {
        if (e.which !== 1 /*LMB*/ || this.touching || !this.enabled) return;

        this._handleStart(e.clientX, e.clientY);

        TouchGallery.attach_listener($(window), "mousemove", this.onMouseMove);
        TouchGallery.attach_listener($(window), "mouseup", this.onMouseUp);

        this.clickTarget = e.target;
        // Attach an event to the target element. This is used to cancel the future click event if we drag
        $(e.target).on("click", this.handleMouseClick);

        e.preventDefault();
    }

    /**
     * @deprecated
     */
    getItemWidth() {
        return this.getItemSize();
    }

    onMouseMove(e) {
        if (!this.touching) return;

        e.preventDefault();
        this._handleMove(e.clientX, e.clientY);
        return false;
    }

    onMouseUp(e) {
        TouchGallery.detach_listener($(window), "mousemove", this.onMouseMove);
        TouchGallery.detach_listener($(window), "mouseup", this.onMouseUp);

        this._handleEnd();
        e.preventDefault();

        let target = this.clickTarget;

        setTimeout(() => {
            $(target).off("click", this.handleMouseClick);
        }, 10);

        this.clickTarget = null;
    }

    onTouchEnd() {
        TouchGallery.detach_listener($(window), "touchmove", this.onTouchMove);
        TouchGallery.detach_listener($(window), "touchend touchcancel", this.onTouchEnd);

        this._handleEnd();
    }

    onTouchMove(e) {
        if (!this.touching) {
            return;
        }
        let touch = e.touches[0];

        if (this._handleMove(touch.clientX, touch.clientY)) {
            if (!TouchGallery.is_ios()) {
                e.preventDefault();
            }
        } else {
            this.onTouchEnd();
        }
    }

    onTouchStart(e) {
        if (this.touching || !this.enabled) {
            return;
        }

        let touch = e.touches[0];

        this._handleStart(touch.clientX, touch.clientY);

        TouchGallery.attach_listener($(window), "touchmove", this.onTouchMove);
        TouchGallery.attach_listener($(window), "touchend touchcancel", this.onTouchEnd);
    }

    setTransform(transform, overDrag = false) {
        if (overDrag) {
            this.transform = transform;
        } else {
            this.transform = ValueHelper.clamp(0, transform, this.getMaxTransform());
        }

        this.updateButtons();

        this.$wrap.css("transform", "translate" + (this.getDirection() === HORIZONTAL ? "X" : "Y") + "(" + (-this.getEffectiveTransform()) + "px)");
    }

    shouldPreventScrolling() {
        return this.swiping;
    }

    stopVelocity() {
        if (this.velocityInterval) {
            clearInterval(this.velocityInterval);
        }
        this.velocityInterval = null;

        this.$wrap.removeClass(this.classes.track.dragging);
        // Force reflow
        this.$wrap.outerWidth();

        this.setTransform(this.getTransform());
    }

    updateButtons() {
        let backwardsEnabled = this.transform > 0;
        let forwardEnabled = this.transform < this.getMaxTransform();

        this.emit("buttons", {
            forwards: forwardEnabled,
            backwards: backwardsEnabled,
        });

        if (this.options.disableButtons) {
            this.$element.find(this.options.selectors.button).removeAttr('disabled');

            if (!backwardsEnabled) {
                this.$element.find(this.options.selectors.button + '[data-direction="backwards"]').attr('disabled', true);
            }

            if (!forwardEnabled) {
                this.$element.find(this.options.selectors.button + '[data-direction="forwards"]').attr('disabled', true);
            }
        }
    }

    updateMaxTransform() {
        if (!this.enabled) {
            this.maxTransform = 0;
            return;
        }

        let width = 0;
        let marginLeft = parseInt(this.getItems().first().css('margin-left'));
        let marginRight = parseInt(this.getItems().first().css('margin-right'));
        let margin = marginLeft + marginRight;

        this.getItems().each(function () {
            let $this = $(this);
            width += $this.outerWidth() + margin;
        });

        this.maxTransform = width - this.$element.outerWidth() - margin;
    }
}

export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';

Track.DEFAULT_OPTIONS = {
    selectors: {
        track: ".js-track",
        item: ".js-track-item",
        button: ".js-track-navigation",
    },
    classes: {
        block: "track",
        track: null,
    },
    disableButtons: true,
    navigateItemCount: 1,
    getNavigateDistance: null,
    direction: HORIZONTAL,
};

